import { gsapAnimationManager } from '../../animation/gsapAnimations'
import { TOOLTIP_OFFSETS } from './constants'

// Tooltip 管理類
export class TooltipManager {
  constructor (dom) {
    if (!dom.countyTooltip || !dom.customTooltip) {
      throw new Error('TooltipManager: Missing required DOM elements')
    }

    this.DOM = dom
    this.tooltipTimeout = null
    this.defaultHeights = {
      parent: 100,
      child: 80
    }
  }

  showCountyTooltip (content) {
    this.DOM.countyTooltip.innerHTML = content
    this.DOM.countyTooltip.style.display = 'block'
    gsapAnimationManager.fadeInTooltip(this.DOM.countyTooltip)
  }

  hideCountyTooltip () {
    gsapAnimationManager.fadeOutTooltip(this.DOM.countyTooltip, {
      duration: 0.15,
      onComplete: () => {
        this.DOM.countyTooltip.style.display = 'none'
      }
    })
  }

  setTooltipContent (html, width = null) {
    this.DOM.customTooltip.innerHTML = html
    this.DOM.customTooltip.style.width = width ? `${width}px` : ''
    this.DOM.customTooltip.style.display = 'block'
    gsapAnimationManager.fadeInTooltip(this.DOM.customTooltip)
  }

  updateTooltipPositionBase (event, offsetX, offsetY, type = 'parent') {
    const tooltip = this.DOM.customTooltip
    const tooltipWidth = tooltip.offsetWidth || 200
    const tooltipHeight = tooltip.offsetHeight || this.defaultHeights[type]

    let left = event.clientX + window.scrollX + offsetX
    let top = event.clientY + window.scrollY - tooltipHeight - offsetY

    // 右邊界檢查
    if (left + tooltipWidth > window.innerWidth) {
      left = window.innerWidth - tooltipWidth - 10
    }
    // 左邊界檢查
    if (left < 0) {
      left = 10
    }
    // 上邊界檢查
    if (top < 0) {
      top = event.clientY + window.scrollY + offsetY
    }
    // 下邊界檢查
    if (top + tooltipHeight > window.innerHeight) {
      top = window.innerHeight - tooltipHeight - 10
    }

    tooltip.style.left = `${left}px`
    tooltip.style.top = `${top}px`
  }

  updateTooltipPosition (event, type = 'parent') {
    const offsets = type === 'parent' ? TOOLTIP_OFFSETS.PARENT : TOOLTIP_OFFSETS.CHILD
    this.updateTooltipPositionBase(event, offsets.x, offsets.y, type)
  }

  hideTooltip () {
    const fadeOutConfig = {
      duration: 0.1,
      onComplete: () => {
        this.DOM.customTooltip.style.display = 'none'
      }
    }
    gsapAnimationManager.fadeOutTooltip(this.DOM.customTooltip, fadeOutConfig)
    this.removeMousemoveListeners()
  }

  removeMousemoveListeners () {
    // 移除所有可能的 mousemove 監聽器
    document.removeEventListener('mousemove', this.updateTooltipPosition, 'parent')
    document.removeEventListener('mousemove', this.updateTooltipPosition, 'child')
  }

  clearTimeout () {
    if (this.tooltipTimeout) {
      clearTimeout(this.tooltipTimeout)
      this.tooltipTimeout = null
    }
  }
}
